/**
 * /css/demo-btn.css
 */

import Send from "./lib/api.js";

export default class DemoButton {
    domRoot;
    domWait;
    domButton;

    constructor() {
        if (!(this.domRoot = document.querySelector(".demo-btn"))) {
            return null;
        }

        if (window.__Variables__?.ProductType === "ecommerce") {
            return;
        }

        this.InsertStyles();
        this.InsertElements();
        this.Listen();
        this.Show();
    }

    InsertStyles() {
        const domLinkStyle = window.CSSDemoButton ?? document.createElement("link");

        if (!domLinkStyle.parentElement) {
            domLinkStyle.setAttribute("id", "CSSDemoButton");
            domLinkStyle.setAttribute("rel", "stylesheet");
            domLinkStyle.setAttribute("type", "text/css");
            domLinkStyle.setAttribute("href", "/css/demo-btn.css");
            document.head.appendChild(domLinkStyle);
        }
    }

    InsertElements() {
        this.domRoot.innerHTML = `<button>CHANGE DESIGN</button>`;

        this.domButton = this.domRoot.querySelector("button");
        this.domWait = document.querySelector(".demo-wait");

        const domLoader = document.createElement("div");
        domLoader.classList.add("demo-wait");

        const domLoaderLogo = document.createElement("img");
        domLoaderLogo.classList.add("demo-wait-logo");
        domLoaderLogo.setAttribute("src", "/img/logotype-black.svg");
        domLoaderLogo.setAttribute("alt", "PGBLDR.com");

        if (!this.domWait) {
            this.domWait = document.querySelector("body").appendChild(domLoader);
            document.querySelector("body").appendChild(domLoaderLogo);
        }
    }

    Listen() {
        this.domButton.addEventListener("click", () => this.onDemoButtonClick());
    }

    Show() {
        this.domRoot.classList.add("show");
    }

    setWait(wait) {
        this.domWait.classList.add("animate");
        this.domWait.classList.toggle("show", wait);
        document.querySelector(".demo-wait-logo").classList.toggle("show", wait);
        document.querySelector(".demo-wait-logo").classList.add("animate");
    }

    onDemoButtonClick() {
        if (this.domWait.className.includes("show")) {
            return;
        }

        this.setWait(true);
        setTimeout(() => {
            Send("/demo", { domain: window.location.hostname, lang: window.__Language__ }).then(res => {
                const { fonts, styles, html, variables } = res;

                // Links / Fonts
                const domLinks = document.head.querySelectorAll("link");
                const domLinksByHref = {};

                for (const domLink of domLinks) {
                    domLinksByHref[domLink.href] = domLink;
                }

                for (const font of fonts) {
                    let domFont = document.createElement("div");
                    domFont.innerHTML = font;
                    domFont = domFont.children[0];

                    if (!domLinksByHref.hasOwnProperty(domFont.href)) {
                        const before = domLinks[domLinks.length - 1];
                        before.parentElement.insertBefore(domFont, before);
                    }
                }

                // Styles
                for (const style of styles) {
                    let domStyle = document.createElement("div");
                    domStyle.innerHTML = style;
                    domStyle = domStyle.children[0];

                    const domStyleCurrent = document.head.querySelector(`style#${domStyle.id}`);
                    domStyleCurrent.parentElement.insertBefore(domStyle, domStyleCurrent);
                    domStyleCurrent.parentElement.removeChild(domStyleCurrent);
                }

                // HTML
                document.body.querySelector("#app").innerHTML = html;

                window.__Variables__ = variables;

                //
                const eXClick = new Event("x-click");
                eXClick._type_ = "SEEDEMO";
                window.dispatchEvent(eXClick);

                // Reactivate
                window.dispatchEvent(new Event("__ReloadElements__"));

                this.setWait(false);
            });
        }, 1000);
    }
}
